// extracted by mini-css-extract-plugin
export var marquee = "marquee-module--marquee--20F4I";
export var inner = "marquee-module--inner--1-F7A";
export var itemGroup = "marquee-module--itemGroup--u1arI";